export function hexToRgb(value) {
  return {
    r: value?.rgba[0] / 255.0,
    g: value?.rgba[1] / 255.0,
    b: value?.rgba[2] / 255.0,
  };
}
